import React from 'react';
import { TbEye } from 'react-icons/tb';
import * as Styled from './style';
import type { NavigateToSectionFn } from '../../../../../consts/types';

interface HighLightCellCommentProps {
  sectionID?: string | null;
  threadID?: string | null;
  onNavigateToSection: NavigateToSectionFn;
}

const HighLightCellComment = ({
  sectionID,
  threadID,
  onNavigateToSection
}: HighLightCellCommentProps) => {
  const handleCellHighLight = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    // first of all we need to make sure that the section/table is rendered into view (bcs we are using virtual scrolling Virtuoso)
    onNavigateToSection(sectionID);
    // wait for some time for cell comments to be rendered
    await new Promise(resolve => setTimeout(resolve, 100));
    if (!threadID) return;

    const cell = document.getElementById(`cell-comment-${threadID}`);
    if (cell) {
      cell.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
      cell.classList.add('highlight-border');
      setTimeout(() => {
        cell.classList.remove('highlight-border');
      }, 1000);
    }
  };

  return (
    <Styled.ThreadHighLightButton
      id={`report-comments-sidebar-highlight-${threadID ?? 'unknown'}`}
      onClick={handleCellHighLight}
    >
      <TbEye color="#868e96" />
    </Styled.ThreadHighLightButton>
  );
};

export default HighLightCellComment;
